var map = {
	"./ClientMapping": 87082,
	"./CreditnoteMapping": 50159,
	"./DeliveryMapping": 60409,
	"./EstimateMapping": 21661,
	"./InvoiceMapping": 97481,
	"./OpportunityMapping": 49536,
	"./OrderMapping": 13723,
	"./PeopleMapping": 62506,
	"./ProformaMapping": 36969,
	"./PropdocumentMapping": 34942,
	"./ProspectMapping": 52760,
	"./PurCreditNoteMapping": 70632,
	"./PurDeliveryMapping": 6692,
	"./PurInvoiceMapping": 8867,
	"./PurOrderMapping": 89506,
	"./StaffMapping": 59704,
	"./SupplierMapping": 38424,
	"./ThirdMapping": 94351
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12976;